import { Component, Output, EventEmitter } from '@angular/core';
import { DocumentItemComponent } from 'app/shared/components/document-item/document-item.component';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-camera-attached-document-item',
  templateUrl: './camera-attached-document-item.component.html',
  styleUrls: ['./camera-attached-document-item.component.scss']
})
export class CameraAttachedDocumentItemComponent extends DocumentItemComponent {
  @Output() delete = new EventEmitter();

  constructor(router: Router,
    activatedRoute: ActivatedRoute) {
    super(router, activatedRoute);
  }

  onDelete() {
    this.delete.emit(this.file);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/camera-attached-document-item/camera-attached-document-item.component.ts